/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Grid } from 'semantic-ui-react'
import MarginHeader from './MarginHeader'
import MarginProductTable from './MarginProductTable'
import { usePlatformsWithCommissions } from './hooks/usePlatformsWithCommissions'
import useBreadcrumb from '../../NavBar/useBreadcrumb'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const Margin = () => {
    const {setPaths} = useBreadcrumb()
    const [t] = useTranslation()
    const {platformsWithCommissions, setCommissionRate, isLoading: platformLoading} = usePlatformsWithCommissions()

    useEffect(() => {
        setPaths([{
            text: t('breadcrumb.home'),
            link: true,
            path: '/',
        }, {
            text: t('breadcrumb.catalog'),
            link: true,
            path: '/products',
        }, {
            text: t('breadcrumb.margin'),
            link: false,
        }])
    }, [setPaths, t])

    return (
      <div css={css`
          position: relative;

      `}>
          <MarginHeader
            platforms={platformsWithCommissions}
            isLoadingPlatforms={platformLoading}
            onCommissionRateUpdate={setCommissionRate}
          />

          {/* Content Section with Left and Right Tables */}
          <Grid css={css`
              margin: 0 !important;
          `}>
              <Grid.Column width={16} css={css`
                  padding-right: 0.5rem !important;
              `}>
                  {!platformLoading && <MarginProductTable platformsCommissions={platformsWithCommissions}

                                                           isLoadingPlatforms={platformLoading}
                  />}
              </Grid.Column>

          </Grid>
      </div>
    )
}

export default Margin
